<script lang="ts" setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps<{
  currentIndex: number;
  total: number;
}>();

const emit = defineEmits<{
  (e: "prev"): void;
  (e: "next"): void;
  (e: "select", index: number): void;
}>();
</script>

<template>
  <div class="flex md:flex-col items-center gap-4">
    <button
      @click="emit('prev')"
      :disabled="props.currentIndex === 0"
      class="group transition-opacity rounded-full hidden md:block"
      :class="
        props.currentIndex === 0
          ? 'opacity-40 cursor-not-allowed'
          : 'opacity-100'
      "
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="transition-colors duration-300 ease-in-out"
      >
        <circle
          cx="28"
          cy="28"
          r="27.5"
          class="stroke-white transition-colors duration-300 ease-in-out group-hover:fill-white"
        />
        <path
          d="M28 36L28 20M28 20L36 28M28 20L20 28"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="stroke-white transition-colors duration-300 ease-in-out group-hover:stroke-active"
        />
      </svg>
    </button>

    <div class="flex md:flex-col gap-2 items-center">
      <span
        v-for="i in props.total"
        :key="i"
        class="w-3 h-3 rounded-full transition-colors cursor-pointer"
        :class="i - 1 === props.currentIndex ? 'bg-white' : 'bg-white/50'"
        @click="emit('select', i - 1)"
      ></span>
    </div>

    <button
      @click="emit('next')"
      :disabled="props.currentIndex === props.total - 1"
      class="group transition-opacity rounded-full hidden md:block"
      :class="
        props.currentIndex === props.total - 1
          ? 'opacity-40 cursor-not-allowed'
          : 'opacity-100'
      "
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="transition-colors duration-300 ease-in-out"
      >
        <circle
          cx="28"
          cy="28"
          r="27.5"
          class="stroke-white transition-colors duration-300 ease-in-out group-hover:fill-white"
        />
        <path
          d="M28 20L28 36M28 36L36 28M28 36L20 28"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="stroke-white transition-colors duration-300 ease-in-out group-hover:stroke-active"
        />
      </svg>
    </button>
  </div>
</template>
